module.exports = __webpack_public_path__ + "img/img1.f47cec8c.png";